import React from 'react';
import PropTypes from 'prop-types';

const StatusStepHeader = (props) => {
  const {
    step,
    stepComplete = false,
    children,
  } = props;

  const headerIconClasslist = [
    'status-step-icon',
  ];

  if (stepComplete) {
    headerIconClasslist.push('complete');
  }

  return (
    <div className="status-step-header larger-bold-font">
      <div className={headerIconClasslist.join(' ')}>{step}</div>
      {children}
    </div>
  );
};

StatusStepHeader.propTypes = {
  step: PropTypes.string.isRequired,
  stepComplete: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.elementType),
    PropTypes.elementType,
  ]).isRequired,
};

export default StatusStepHeader;
